import React, { useState } from "react";
import  Button  from "../../Components/ui/button";
import Right from '../../Images/RightSvg.svg'
import EasyOfficeLogo from '../../Images/New/Products/easyOffice.webp'
import EasyAccLogo from '../../Images/New/Products/easyAcc.webp'
import EO1 from "../../Images/New/OtherProducts/EO/1.gif";
import EO2 from "../../Images/New/OtherProducts/EO/2.gif";
import EO3 from "../../Images/New/OtherProducts/EO/3.gif";
import EO4 from "../../Images/New/OtherProducts/EO/4.gif";
import EO5 from "../../Images/New/OtherProducts/EO/5.gif";
import EO6 from "../../Images/New/OtherProducts/EO/6.gif";
import EO7 from "../../Images/New/OtherProducts/EO/7.gif";
import EO8 from "../../Images/New/OtherProducts/EO/8.gif";
import EA1 from "../../Images/New/OtherProducts/EA/1.gif";
import EA2 from "../../Images/New/OtherProducts/EA/2.gif";
import EA3 from "../../Images/New/OtherProducts/EA/3.gif";
import EA4 from "../../Images/New/OtherProducts/EA/4.gif";
import EA5 from "../../Images/New/OtherProducts/EA/5.gif";
import EA6 from "../../Images/New/OtherProducts/EA/6.gif";
import EA7 from "../../Images/New/OtherProducts/EA/7.gif";
import EA8 from "../../Images/New/OtherProducts/EA/8.gif";

const OtherProduct = () => {

  const [isExpanded1, setIsExpanded1] = useState(false);

  const toggleExpand1 = () => {
    setIsExpanded1(!isExpanded1);
  };

  const [isExpanded2, setIsExpanded2] = useState(false);

  const toggleExpand2 = () => {
    setIsExpanded2(!isExpanded2);
  };
  

  return (
    <>
      <div className="w-full sm:py-20 sm:pr-10 p-3 relative bg-[#f1f5f8] flex justify-center">
        <div className="w-full max-w-7xl">
          <div className="text-center mb-5">
            <p className="text-4xl text-black font-bold">
              Our Other Product<span className="text-[#519980]">'s</span>
            </p>
          </div>
          <div className="flex flex-col-reverse sm:flex-row justify-evenly w-full items-center bg-[#ffffff] py-4 border-2 border-[#7decc6] rounded-2xl mb-12">
            <div className="sm:w-1/2 sm:p-0 pt-4 flex justify-center items-center">
              {/* <img
                src={EasyOfficeBG}
                className="sm:w-[60%] sm:p-5 p-3 border-2 border-[#519980] rounded-2xl shadow-2xl hover:shadow-none"
                alt=""
              /> */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 px-5 pr-8">
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EO1} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Quick ITR Upload
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EO4} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    TDS & TCS Returns
                  </p>
                </div>

                <div className="bg-white flex items-center border-2 border-[#7decc6] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EO3} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    e-Audit Report
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EO2} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Balance Sheet
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EO5} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    CMA Data Preparation
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EO6} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Online Tax Payment
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EO7} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Multiangle Analysis Reports
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EO8} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Office Management Utilities
                  </p>
                </div>
              </div>
            </div>
            <div className="sm:w-1/2 px-3 sm:px-0">
              <div className="pr-12">
                {/* <p className="mb-5 text-[#000000] text-3xl font-bold">
                  EasyOFFICE
                </p> */}
                <img
                  src={EasyOfficeLogo}
                  alt="EasyOffice Logo"
                  className="w-[30%] mb-5 mt-2"
                />
                <p className="mb-3 text-[#000000] text-xl font-bold">
                  Powerful & Preferred Taxation Software with the Best Price
                </p>
                <p className="mb-0 text-black font-medium text-lg">
                  EasyOFFICE is an integrated Taxation Software with the motto
                  of Complete Office Management for Chartered Accountants (CA),
                  Tax Professionals and Tax Advocates. This flagship product is
                  a bundle of many software modules & utilities like Income Tax
                  Software (EasyTax), TDS software (EasyTDS), Audit Report &
                  Balance Sheet software (EasyAudit), CMA Data software
                  (EasyCMA), Office Management Utilities & more.
                </p>
                {isExpanded1 && (
                  <div>
                    <p className="my-3 text-black font-medium text-lg">
                      EasyOFFICE Tax return filing software is exclusively
                      designed and developed as per the system specified by the
                      Income Tax Department of India, Protean and TRACES.
                    </p>
                    <p className="mb-3 text-black font-medium text-lg">
                      EasyOFFICE India’s Top Tax Return filing software also
                      offers Multiple other features like Back up, Restore,
                      EasyForm, MyInvoice, User Data Access Management, XML /
                      JSON file import & many more. Calculating your income and
                      tax liability, self-assessment tax, advance tax, Arrears,
                      26AS / AIS / TIS data direct Import and interest as per
                      sections 234A, 234B, 234C & 234F has been made simple with
                      EasyTAX software. All such features, Accuracy &
                      user-friendly operation makes EasyOFFICE as Best Income
                      Tax Software among tax professionals in India.
                    </p>
                    <p className="mb-3 text-black font-medium text-lg">
                      EasyAUDIT software incorporates various forms such as 3CA,
                      3CB, 3CD, 3CEB, 29B, 10B allows the preparation of audit
                      reports & account statements as per Tax Audit and Company
                      audit Schedules. EasyAudit is the Preferred choice among
                      CA’s for audit report efiling. Managing TDS quarterly
                      e-Return for 24Q, 26Q, 27Q, 27EQ, TDS Correction, Data
                      Import options, Interest calculation, Online data
                      automation tools & Multiple analysis reports makes it the
                      Best TDS Return filing software. EasyCMA is the best
                      software for preparing and calculating CMA Data.
                    </p>
                    <p className="mb-3 text-black font-medium text-lg">
                      The software's return filing capability is a key feature
                      that streamlines the tax preparation and filing process,
                      ensuring accuracy and compliance with the latest
                      regulations. With its robust features and Powerful user
                      interface, Electrocom's EasyOFFICE - A Complete Taxation
                      Software is a trusted solution and valuable asset for
                      professionals seeking to optimize their tax preparation &
                      filing processes with ease.EasyOffice Software demo can be
                      downloaded free of cost.
                    </p>
                  </div>
                )}
                <button onClick={toggleExpand1} className="mt-2 cursor-pointer">
                  {isExpanded1 ? "Show Less" : "Show More"}
                </button>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      Income Tax Software
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      Balance Sheet Software
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      TDS Return Software
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      CMA Software
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      {" "}
                      Audit e-filing Software
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      {" "}
                      Office Utilities
                    </p>
                  </div>
                </div>
              </div>
              <div className="sm:flex grid grid-cols-1 mt-5">
                <a
                  href="https://www.easyofficesoftware.com/public/demo/demo/EasyOfficeDemoSetup.exe"
                  target="_blank"
                  rel="noreferrer"
                  className="mt-3"
                >
                  <div className="">
                    <Button label={"Download Demo"} />
                  </div>
                </a>
                <a
                  href="https://www.easyofficesoftware.com/public/catalogue/EasyOFFICE-CATALOGUE.pdf"
                  target="_blank"
                  rel="noreferrer"
                  className="sm:ml-3 mt-3"
                >
                  <div className="">
                    <Button label={"Catalogue"} />
                  </div>
                </a>
                <a
                  href="https://www.easyofficesoftware.com/easyofficesoftware"
                  target="_blank"
                  rel="noreferrer"
                  className="sm:ml-3 mt-3"
                >
                  <div className="">
                    <Button label={"View More"} />
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row justify-evenly w-full items-center bg-[#ffffff] py-4 border-2 border-[#7decc6] rounded-2xl">
            <div className="sm:w-1/2 p-3 sm:pl-20">
              <div className="">
                {/* <p className="mb-5 text-[#000000] text-3xl font-bold">
                  EasyACC
                </p> */}
                <img
                  src={EasyAccLogo}
                  alt="EasyAccLogo"
                  className="w-[35%] mb-5"
                />
                <p className="mb-3 text-[#000000] text-xl font-bold">
                  Accounting Inventory Invoicing Management Software
                </p>
                <p className="mb-0 text-[#000000] text-lg font-medium">
                  EasyACC is a Complete Accounting, Inventory & Invoicing
                  Management software. This financial accounting software is
                  widely used by small and medium businesses, traders,
                  retailers, dealers, distributors and manufacturing units.With
                  its user-friendly advanced features, EasyACC Software is an
                  ideal solution for businesses looking to simplify their
                  Billings, Cash / Cheque management, payment reminders, Orders
                  and other financial operations.
                </p>
                {isExpanded2 && (
                  <div>
                    <p className="my-3 text-black text-lg font-medium">
                      EasyACC is the Best Accounting software for growing
                      Businesses. EasyACC Software is available with special
                      modules for the Textile industry, Garment industry,
                      Engineering units, Job works, Agency business and Travel
                      agents. The software's invoicing & inventory management
                      capabilities provide a simple and efficient way to manage
                      sales & stock, while its annual financial statement
                      feature provides a comprehensive view of a business's
                      financial performance. EasyACC Software demo can be
                      downloaded free of cost.
                    </p>
                    <p className="mb-3 text-black text-lg font-medium">
                      EasyACC software's account book, bank / cash / JV /
                      voucher and debit note / credit note features provide a
                      complete view of all financial transactions, enabling
                      businesses to effectively manage their financial
                      operations. Additionally, the software's e-way bill
                      generation, GST reports & analysis, purchase management,
                      inventory management, bank management and cash management
                      capabilities provide a comprehensive solution for
                      businesses looking to optimize their financial operations
                      and stay compliant with the latest regulations. To Keep
                      our customers up-dated with current market needs we
                      regularly update & add new features to the software.
                      EasyACC is the best Billing Software for Small Businesses
                      in India.
                    </p>
                  </div>
                )}
                <button onClick={toggleExpand2} className="mt-2 cursor-pointer">
                  {isExpanded2 ? "Show Less" : "Show More"}
                </button>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      Invoicing
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      E-Invoicing
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      Inventory
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      Debit note/Credit note
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      {" "}
                      Account Books
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      {" "}
                      Bank/Cash/JV/Ledger
                    </p>
                  </div>
                </div>
              </div>
              <div className="sm:flex grid grid-cols-1 mt-5">
                <a
                  href="https://www.easyofficesoftware.com/public/demo/demo/EasyAccDemoSetup.exe"
                  target="_blank"
                  rel="noreferrer"
                  className=" mt-3"
                >
                  <div className="">
                    <Button label={"Download Demo"} />
                  </div>
                </a>
                <a
                  href="https://www.easyofficesoftware.com/public/catalogue/EasyACC-CATALOGUE.jpg"
                  target="_blank"
                  rel="noreferrer"
                  className="sm:ml-3 mt-3"
                >
                  <div className="">
                    <Button label={"Catalogue"} />
                  </div>
                </a>
                <a
                  href="https://www.easyofficesoftware.com/easyacc"
                  target="_blank"
                  rel="noreferrer"
                  className="sm:ml-3 mt-3"
                >
                  <div className="">
                    <Button label={"View More"} />
                  </div>
                </a>
              </div>
            </div>
            <div className="sm:w-1/2 p-6 sm:p-0 flex justify-center items-center">
              {/* <img
                src={EasyAccBG}
                className="sm:w-[60%] sm:p-5 p-3 border-2 border-[#519980] rounded-2xl shadow-2xl hover:shadow-none"
                alt=""
              /> */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 px-5 pr-8">
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EA1} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Accounting Management
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EA2} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Billing Management
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EA3} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Inventory Management
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EA4} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    GST Returns & Reports
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EA5} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Final Account Statements
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EA6} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    E- Invoice / E-way Bill
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EA7} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Data Import & Export
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#7decc6] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EA8} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Special Modules for Various Businesses
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OtherProduct;
